import React from 'react';

const Logo = () => {
  return (
      <div>
        <svg viewBox={'0 0 675 350'}>
          <polygon
            className={'line-through'}
            points={'0,147.336 0,196.053 82.691,196.053 78.058,147.336'}
          />
          <polygon
            className={'line-through'}
            points={'171.301,147.336 175.941,196.053 377.521,196.053 369.434,147.336'}
          />
          <polygon
            className={'line-through'}
            points={'458.282,147.333 467.617,196.053 675,196.053 675,147.333 '}
          />

          <path
            className={'w'}
            d={'M607.527,0.37h-54.547c-0.956,45.974-2.271,88.236-5.118,130.482h54.021C605.263,79.688,605.368,34.48,607.527,0.37'}
          />
          <path
            className={'w'}
            d={'M594.916,211.922h-53.767c-8.21,56.767-22.162,89.267-46.666,90.694C440.224,305.769,453.19,2.325,349.73,0.362c-47.456,0.898-70.41,61.044-86.6,130.119h49.91c7.603-37.225,17.372-60.197,36.69-61.112c63.119,2.993,24.358,285.997,140.767,285.997C555.402,355.367,582.676,292.634,594.916,211.922'}
          />
          <path
            className={'w'}
            d={'M246.718,211.923c-11.359,54.465-22.277,91.898-43.029,90.691C154.631,299.763,147.868,147.434,144.804,0H90.257c6.657,105.117-6.237,355.367,117.419,355.367c60.33,0,78.98-69.794,91.735-143.445H246.718z'}
          />
        </svg>
    </div>
  );
};

export default Logo;
